import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-foldername-dialog',
  templateUrl: './change-foldername-dialog.component.html',
  styleUrls: ['./change-foldername-dialog.component.scss']
})
export class ChangeFoldernameDialogComponent implements OnInit {

  form: UntypedFormGroup;
  textFiltersMaxLength = 100;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<ChangeFoldernameDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      nameFolder: ['', [Validators.required, Validators.maxLength(256)]],
    });
    this.form.get('nameFolder').setValue(this.data.name);
    console.log(this.data);
  }

  onCancel(){
    this.dialogRef.close();
  }

  onSave(){
    let response = {
      name: this.form.get('nameFolder').value,
      id: this.data.id,
      parentId: this.data.parentFolderId
    };
    this.dialogRef.close(response);
  }

}
